export default import.meta.ROLLUP_FILE_URL_8n0DI0MywxZ9$kTK1ydnLw